import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListEPP } from "../../../components/Admin/EPP";

export function EPP() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload(p => !p);

  const panes = [
    {
      menuItem: "EPP Activos",
      render: () => (
        <Tab.Pane attached={false}>
          <ListEPP active={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "EPP Inactivos",
      render: () => (
        <Tab.Pane attached={false}>
          <ListEPP active={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div style={{ padding: "1.5rem" }}>
      <div style={{ marginBottom: "1rem" }}>
        <span style={{ fontSize: "1.3rem", fontWeight: 600 }}>Equipos de Protección Personal (EPP)</span>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
